(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["agr-homepage"] && !Shopify.designMode) return;
  try {
    
  function initAGRVideoCarousels(root) {
    root.querySelectorAll('[data-agr-video-carousel]').forEach((carousel) => {
      if (carousel.dataset.carouselReady === 'true') return;
      carousel.dataset.carouselReady = 'true';

      const viewport = carousel.querySelector('[data-carousel-viewport]');
      const slides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
      const dots = Array.from(carousel.querySelectorAll('[data-carousel-dot]'));
      const previous = carousel.querySelector('[data-carousel-prev]');
      const next = carousel.querySelector('[data-carousel-next]');
      let activeIndex = 0;
      let ticking = false;

      if (!viewport || slides.length === 0) return;

      const update = (index) => {
        activeIndex = (index + slides.length) % slides.length;
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === activeIndex));
      };

      const goTo = (index) => {
        update(index);
        viewport.scrollTo({ left: slides[activeIndex].offsetLeft, behavior: 'smooth' });
      };

      previous.addEventListener('click', () => goTo(activeIndex - 1));
      next.addEventListener('click', () => goTo(activeIndex + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));

      viewport.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          let closestIndex = 0;
          let closestDistance = Infinity;
          slides.forEach((slide, index) => {
            const distance = Math.abs(slide.offsetLeft - viewport.scrollLeft);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });
          update(closestIndex);
          ticking = false;
        });
      }, { passive: true });
    });
  }

  initAGRVideoCarousels(document);
  document.addEventListener('shopify:section:load', (event) => initAGRVideoCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
